import { render, staticRenderFns } from "./FindMTRight.vue?vue&type=template&id=31271f42&scoped=true"
import script from "./FindMTRight.vue?vue&type=script&lang=js"
export * from "./FindMTRight.vue?vue&type=script&lang=js"
import style0 from "./FindMTRight.vue?vue&type=style&index=0&id=31271f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31271f42",
  null
  
)

export default component.exports